import { Reveal, GhostButton } from "@/components/common";
import { CONTACT_EMAIL } from "@/lib/data";
import { useI18n } from "@/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useFormModal } from "@/lib/formContext";

// Render an answer string, turning the support email into a clickable mailto link.
function renderAnswer(text) {
  const parts = text.split(CONTACT_EMAIL);
  if (parts.length === 1) return text;
  return parts.flatMap((part, i) =>
    i === 0
      ? [part]
      : [
          <a key={i} href={`mailto:${CONTACT_EMAIL}`} className="text-re-red hover:underline" data-testid="faq-contact-email">
            {CONTACT_EMAIL}
          </a>,
          part,
        ]
  );
}

export function FAQ() {
  const { openForm } = useFormModal();
  const { t } = useI18n();
  const faqs = t("faq.items");
  return (
    <section id="faq" className="bg-white py-24 md:py-32" data-testid="faq">
      <div className="container-re">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <Reveal>
            <h2 className="pb-1 font-heading text-3xl font-black leading-[1.14] tracking-tight text-re-ink md:text-5xl">
              {t("faq.title")} <span className="text-gradient-red">{t("faq.titleAccent")}</span>.
            </h2>
            <p className="mt-5 text-base text-re-muted md:text-lg">
              {t("faq.sub")}
            </p>
            <div className="mt-8 rounded-3xl border border-re-line bg-re-soft/50 p-7">
              <p className="font-heading text-lg font-bold text-re-ink">{t("faq.notListed")}</p>
              <div className="mt-4">
                <GhostButton testid="faq-contact-cta" onClick={() => openForm()}>
                  {t("faq.contactCta")}
                </GhostButton>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-re-line"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-5 text-left font-heading text-lg font-bold text-re-ink hover:text-re-red hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] leading-relaxed text-re-muted">
                    {renderAnswer(f.a)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
